import { variables, $ } from '../common/variables';
import { cl, ajax } from '../common/functions';

const toggleEntities = (entityContainer) => {
  if (!!entityContainer.length) {
    for (let i = 0; i < entityContainer.length; i++) {
      entityContainer[i].querySelector('.toggle__title').addEventListener('click', e => {
        e.preventDefault();
        e.target.classList.toggle('is-open');

        const entityWrapper = entityContainer[i].querySelector('.entity__wrapper');
        entityWrapper.classList.toggle('entity__wrapper--visible');
        const entityMapContainer = entityContainer[i].querySelector(`.entity__map`);
        if (entityMapContainer) {
          /*------------ [LEAFLET] ------------*/
          //Check si le container de la map a déjà été initialisé
          const entityMapContainerID = entityMapContainer.id;
          if (entityWrapper.classList.contains('entity__wrapper--visible')) {
            window.leafletLib = {};
            const container = L.DomUtil.get(entityMapContainerID);
            if (container) {
              container._leaflet_id = container._leaflet_id ? null : null;
            }
            //Creation de la map
            const map = L.map(entityMapContainerID, {
              gestureHandling: true
            });
            leafletLib.map = map;
            const osmUrl = 'https://stamen-tiles-{s}.a.ssl.fastly.net/toner-lite/{z}/{x}/{y}{r}.png';
            const osmAttrib = 'Map data © OpenStreetMap contributors';
            const osm = new L.TileLayer(osmUrl, { attribution: osmAttrib });
            map.addLayer(osm);
            //Setview par défaut de la map
            map.setView([47.0, 3.0], 5);

            const entityLongitude = entityContainer[i].querySelector(`.gl__longitude`);
            const entityLatitude = entityContainer[i].querySelector(`.gl__latitude`);
            if (entityLongitude !== null && entityLatitude !== null) {
              const latitude = entityLatitude.value;
              const longitude = entityLongitude.value;
              const marker = L.marker([latitude, longitude], {
                draggable: true,
                autoPan: true
              });
              marker.addTo(map);
              map.setView([latitude, longitude], 5);
              //ajoute le marker au window
              leafletLib.marker = marker;
              // drag le marker si besoin et renplace les nouvelles coordonnées
              marker.on('dragend', e => {
                const position = marker.getLatLng();
                const changeCoordinates = (element, coordinate) => {
                  element.value = coordinate;
                  const id = element.dataset.id;
                  const fieldname = element.dataset.fieldname;
                  const table = element.dataset.table;
                  const name = element.dataset.name;
                  const params = {
                    action: 'edit_fields_ajax',
                    id: id,
                    value: coordinate,
                    fieldname: fieldname,
                    table: table,
                    name: name
                  };
                  ajax(params, success, error, 'json');
                };
                changeCoordinates(entityLatitude, position.lat);
                changeCoordinates(entityLongitude, position.lng);
              });
            }

            /*------------ [AJAX] success------------*/
            const success = data => {
              const notyf = new Notyf();
              if (data.success === true) {
                notyf.success('Your changes have been successfully saved!');
              } else {
                notyf.error('Oops something went wrong');
              }
            };

            /*------------ [AJAX] error------------*/
            const error = err => {
              const notyf = new Notyf();
              notyf.error('Oops something went wrong');
              cl(err);
            };

          } else {
            window.leafletLib = {};
            entityMapContainer.innerHTML = '';
            entityMapContainer.className = 'entity__map';
            entityMapContainer.removeAttribute('style');
            entityMapContainer.removeAttribute('tabindex');
            entityMapContainer.removeAttribute('data-gesture-handling-touch-content');
            entityMapContainer.removeAttribute('data-gesture-handling-scroll-content');
          }
        }
      });
    }
  }
}

export { toggleEntities }
